import { createSlice } from '@reduxjs/toolkit';

const roleSlice = createSlice({
    name: 'role',
    initialState: {
      userEmail: '',
      userName: '',
      orgName: '',
      userId:-1,
      homeLink: '',
      userCurrRole: '',
      roles:[],
      workingHoursList:[],
      isChatEnabled:false,
      isBotChatEnabled:false,
      isAgentChatEnabled:false,
      isFAQEnabled:false,
      isCallbackEnabled:false,
      isWorkingTime:false,
      serviceUserId:-1,
    },
    reducers: {
      setUserInfo: (state, action) => {
        const { userEmail, userName, orgName, userId, userCurrRole, homeLink, roles,isChatEnabled,isBotChatEnabled,isCallbackEnabled,isAgentChatEnabled,isFAQEnabled,isWorkingTime,workingHoursList,serviceUserId} = action.payload;
        state.userEmail = userEmail;
        state.userName = userName;
        state.orgName = orgName;
        state.userId = userId;
        state.homeLink = homeLink;
        state.userCurrRole = userCurrRole;
        state.roles = roles;
        state.isChatEnabled=isChatEnabled;
        state.isBotChatEnabled=isBotChatEnabled;
        state.isCallbackEnabled=isCallbackEnabled;
        state.isAgentChatEnabled=isAgentChatEnabled;
        state.isFAQEnabled=isFAQEnabled;
        state.isWorkingTime =isWorkingTime;
        state.workingHoursList =workingHoursList;
        debugger
        state.serviceUserId=serviceUserId;
      },
    },
  },
);

export const { setUserInfo } = roleSlice.actions;
export default roleSlice.reducer;